import { cn } from 'Features/Shared/Utils/classNames';
import * as React from 'react';

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, ...props }, ref) => {
    return (
      <select
        className={cn(
          'block w-full rounded-lg border-0 ring-1 ring-inset ring-zinc-200 px-4 py-3 text-sm shadow-sm focus:ring-2 focus:ring-inset focus:ring-blue-500',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

Select.displayName = 'Select';

export { Select };
